import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { EditorModule } from '@tinymce/tinymce-angular';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { init } from '../../pages/editorconfig';

@Component({
  selector: 'app-needfrom',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    EditorModule,
    InputTextModule,
    DropdownModule
  ],
  templateUrl: './needfrom.component.html',
  styleUrl: './needfrom.component.scss'
})
export class NeedfromComponent implements OnInit, OnChanges {
  @Input() data: any = null;

  init: EditorComponent['init'] = init;
  isEditorDisabled: boolean = true;
  technicalDetailsValue: string = '';
  justificationTextValue: string = '';
  exportPotentialValue: string = '';

  expandedSections: { [key: string]: boolean } = {
    basicInfo: true,
    equipment: true,
    quantity: true,
    cost: true,
    detailedInfo: true
  };

  tenderModes = [
    { label: 'Open Tender', value: 'Open Tender' },
    { label: 'Single Tender', value: 'Single Tender' },
    { label: 'Limited Tender', value: 'Limited Tender' },
  ];

  // Computed properties for display
  get nomenclature(): string {
    return this.data?.nomenclature || '';
  }

  get platform(): string {
    return this.data?.platform || '';
  }

  get modeTender(): string {
    return this.data?.mode_tendor || '';
  }

  get equipmentName(): string {
    return this.data?.equipment?.name || '';
  }

  get systemName(): string {
    return this.data?.system?.name || '';
  }

  get quantityRequired(): string {
    return this.data?.qty_req || '';
  }

  get quantityPrototype(): string {
    return this.data?.prototype_qty || '';
  }

  get quantityBulk(): string {
    return this.data?.bulk_qty || '';
  }

  get estimatedTotalCost(): string {
    return this.data?.amount || this.data?.development_cost || '';
  }

  get estimatedUnitCost(): string {
    return this.data?.unit_cost && this.data?.unit_cost !== 'null' ? this.data.unit_cost : '';
  }

  get llpCost(): string {
    return this.data?.lpp_cost && this.data?.lpp_cost !== 'null' ? this.data.lpp_cost : '';
  }

  get poevCost(): string {
    return this.data?.poev && this.data?.poev !== 'null' ? this.data.poev : '';
  }

  get consignee(): string {
    return this.data?.consignee && this.data?.consignee !== 'null' ? this.data.consignee : '';
  }

  get technicalDetails(): string {
    return this.data?.technical_details && this.data?.technical_details !== 'null' ? this.data.technical_details : '';
  }

  get justificationText(): string {
    return this.data?.justification && this.data?.justification !== 'null' ? this.data.justification : '';
  }

  get exportPotential(): string {
    return this.data?.proposed_item && this.data?.proposed_item !== 'null' ? this.data.proposed_item : '';
  }

  ngOnInit(): void {
    // Set editor to readonly mode
    this.init = {
      ...init,
      readonly: true
    };
    this.updateTechnicalDetails();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && changes['data'].currentValue) {
      this.updateTechnicalDetails();
    }
  }

  private updateTechnicalDetails(): void {
    this.technicalDetailsValue = this.technicalDetails;
  }

  toggleSection(section: string) {
    this.expandedSections[section] = !this.expandedSections[section];
  }
}
